import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_Phq = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_Phq' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>PHQ-9 modified for Adolescents (PHQ-A)</h3></p>

                <p className='w-750'><h4>Instructions:</h4>How often have you been bothered by each of the following symptoms during the past Two Weeks? For each symptom put an "X" in the box beneath the answer that best describes how you have been feeling.</p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'><br />&nbsp;<br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>(0) Not at all <br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>(1) Several Days <br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>(2) More than half the days</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>(3) Nearly every day <br />&nbsp;</span></td>

                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-350'>1. Feeling down, depressed, irritable, or hopeless?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingDownDepressed_1' name='rbFeelingDownDepressed' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingDownDepressed_2' name='rbFeelingDownDepressed' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingDownDepressed_3' name='rbFeelingDownDepressed' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingDownDepressed_4' name='rbFeelingDownDepressed' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>2. Little interest or pleasure in doing things?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestPleasureDoing_1' name='rbLittleInterestPleasureDoing' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestPleasureDoing_2' name='rbLittleInterestPleasureDoing' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestPleasureDoing_3' name='rbLittleInterestPleasureDoing' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestPleasureDoing_4' name='rbLittleInterestPleasureDoing' className='add-only' value='4' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-350'>3. Trouble falling asleep, staying asleep ,or sleeping too much ?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingAsleep_1' name='rbTroubleFallingAsleep' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingAsleep_2' name='rbTroubleFallingAsleep' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingAsleep_3' name='rbTroubleFallingAsleep' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingAsleep_4' name='rbTroubleFallingAsleep' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>4. Poor appetite, weight loss, or overeating?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteWeightLoss_1' name='rbPoorAppetiteWeightLoss' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteWeightLoss_2' name='rbPoorAppetiteWeightLoss' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteWeightLoss_3' name='rbPoorAppetiteWeightLoss' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteWeightLoss_4' name='rbPoorAppetiteWeightLoss' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>5. Feeling tired, or having little energy?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingEnergy_1' name='rbFeelingTiredOrHavingEnergy' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingEnergy_2' name='rbFeelingTiredOrHavingEnergy' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingEnergy_3' name='rbFeelingTiredOrHavingEnergy' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingEnergy_4' name='rbFeelingTiredOrHavingEnergy' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>6. Feeling bad about yourself or feeling that you are a failure, or that you have let youself or your family down?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourSelf_1' name='rbFeelingBadAboutYourSelf' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourSelf_2' name='rbFeelingBadAboutYourSelf' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourSelf_3' name='rbFeelingBadAboutYourSelf' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourSelf_4' name='rbFeelingBadAboutYourSelf' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>7. Trouble concentrating on things like school work, reading, or watching TV?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleConcentratingOnThingsLikeWatching_1' name='rbTroubleConcentratingOnThingsLikeWatching' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleConcentratingOnThingsLikeWatching_2' name='rbTroubleConcentratingOnThingsLikeWatching' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleConcentratingOnThingsLikeWatching_3' name='rbTroubleConcentratingOnThingsLikeWatching' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleConcentratingOnThingsLikeWatching_4' name='rbTroubleConcentratingOnThingsLikeWatching' className='add-only' value='4' /></center></td>

                    </tr>

                    <tr>
                        <td className='w-350'>8. Moving or speaking so slowly that other people could have noticed? Or the opposite-being so fidgety or restless that you were moving around a lot more than usual?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingSpeakingSlowlyThatPeople_1' name='rbMovingSpeakingSlowlyThatPeople' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingSpeakingSlowlyThatPeople_2' name='rbMovingSpeakingSlowlyThatPeople' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingSpeakingSlowlyThatPeople_3' name='rbMovingSpeakingSlowlyThatPeople' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingSpeakingSlowlyThatPeople_4' name='rbMovingSpeakingSlowlyThatPeople' className='add-only' value='4' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-350'>9. Thoughts that you would be better off dead, or of hurting yourself in some way?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtsThatYouWouldBeBetterDead_1' name='rbThoughtsThatYouWouldBeBetterDead' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtsThatYouWouldBeBetterDead_2' name='rbThoughtsThatYouWouldBeBetterDead' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtsThatYouWouldBeBetterDead_3' name='rbThoughtsThatYouWouldBeBetterDead' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtsThatYouWouldBeBetterDead_4' name='rbThoughtsThatYouWouldBeBetterDead' className='add-only' value='4' /></center></td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>In the past year have you felt depressed or sad most days, even if you felt okay sometimes?</span>
                    <input type='radio' id='rbInThePastYearHave_Yes' name='rbInThePastYearHave' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInThePastYearHave_No' name='rbInThePastYearHave' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>If you are experiencing any of the problems on this form , how difficult have these problems made if for you to do you work, take care of things at home or get along with other people?</span>
                    <input type='radio' id='rbIfYouAreExperiencingAnyProblems_Yes' name='rbIfYouAreExperiencingAnyProblems' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIfYouAreExperiencingAnyProblems_No' name='rbIfYouAreExperiencingAnyProblems' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Has there been a time in the past month when you have had serious thought about ending your life?</span>
                    <input type='radio' id='rbHasThereBeenTimeInThePastMonth_Yes' name='rbHasThereBeenTimeInThePastMonth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasThereBeenTimeInThePastMonth_No' name='rbHasThereBeenTimeInThePastMonth' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Have you EVER in you WHOLE LIFE, tried to kill yourself or made a suicide attempt?</span>
                    <input type='radio' id='rbHaveYouEverYourWholeLifeTriedKillYourself_Yes' name='rbHaveYouEverYourWholeLifeTriedKillYourself' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouEverYourWholeLifeTriedKillYourself_No' name='rbHaveYouEverYourWholeLifeTriedKillYourself' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><sup>***</sup>If you have had thoughts that you would be better off dead or of hurting yourself in some way, please discuss this with your Health Care Clinician, go to a hospital emergency room or call 911.
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Office Use only:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Severity Score:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOfficeUseOnly' name='txtOfficeUseOnly' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='text' id='txtSeverityScore' name='txtSeverityScore' className='add-only'/></td>
                    </tr>
                </table>

                <p className='w-750'><span className='small'>Modified with permission from the PHQ (Spitzer, Williams & Kroenka, 1999) by J.Johnson (Johnson,2002)</span>
                </p>



            </div>
        </form>

    )
}   